import { Module } from 'vuex';
import get from '@/api/get';

interface CompaniesState {
  companies: any[];
  loading: boolean;
  error: string | null;
}

const companiesModule: Module<CompaniesState, any> = {
  state: {
    companies: [],
    loading: false,
    error: null
  },

  mutations: {
    SET_COMPANIES(state, companies) {
      state.companies = companies;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },

  actions: {
    async getCompanies({ state, commit }) {
      // If companies already exist in store, return them
      if (state.companies && state.companies.length > 0) {
        return state.companies;
      }

      // If not in store, make API call
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const res = await get('/api/companies');
        const companies = res.data || [];
        
        commit('SET_COMPANIES', companies);
        return companies;
      } catch (error) {
        console.error('Error fetching companies:', error);
        commit('SET_ERROR', 'Failed to fetch companies');
        return [];
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },

  getters: {
    allCompanies: (state) => state.companies,
    companiesCount: (state) => state.companies.length,
    isLoadingCompanies: (state) => state.loading,
    companiesError: (state) => state.error
  }
};

export default companiesModule;
